export const isPageHidden = (userData: UserData | undefined, id: string | number) => {
    const pageId = typeof id === 'string' ? parseInt(id) : id;
    const isHidden = userData?.hiddenPages?.includes(pageId);

    return isHidden ?? false;
};
